var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    { staticClass: "nti-filter-pager" },
    [
      _vm.displayPager
        ? [
            _vm.decrementPage
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "nti-filter-pager__button",
                      on: { click: _vm.decrementPage.clickHandler },
                    },
                    [
                      _c("div", { staticClass: "nti-svg__container-small" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 320 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "nti-filter-pager__number-button__container" },
              [
                _vm._l(_vm.pagerRenderData, function (page, index) {
                  return [
                    page.type === "page"
                      ? [
                          _c(
                            "button",
                            {
                              key: index,
                              ref: page.current ? "activepage" : "donotfocusme",
                              refInFor: true,
                              staticClass:
                                "nti-filter-pager__number-button nti-filter-pager__button",
                              class: page.current
                                ? "nti-filter-pager--current"
                                : "",
                              on: { click: page.clickHandler },
                            },
                            [_vm._v(_vm._s(page.displayNumber))]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    page.type === "split"
                      ? [_c("span", { key: index }, [_vm._v("...")])]
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.incrementPage
              ? [
                  _c(
                    "button",
                    {
                      staticClass:
                        "nti-filter-pager__next-button nti-filter-pager__button",
                      on: { click: _vm.incrementPage.clickHandler },
                    },
                    [
                      _c("div", { staticClass: "nti-svg__container-small" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 320 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }